<template>
  <v-container grid-list-xl>
    <v-layout row wrap>
      <v-flex xs4 v-for="(item, key) in videoArr" :key="key">
        <v-card @mouseover="show = key" @mouseout="show = null">
          <v-img
            :src="`https://unsplash.it/360/200?image=${item.video_id + random}`"
            aspect-ratio="2.33"
          ></v-img>
          <v-card-title class="d-block video-name">{{item.video_name}}</v-card-title>
          <v-card-text>
            <span>{{item.upload_date | changeDateFormat}}</span>
            <span>{{item.video_appointment}}</span>
          </v-card-text>
          <div class="hover-overlay" v-show="show === key">
            <p class="hover-overlay-title d-block video-name">{{item.video_name}}</p>
            <div class="hover-overlay-info">
              <span>{{item.upload_date | changeDateFormat}}</span>
              <span>{{item.video_appointment}}</span>
            </div>
            <div class="hover-overlay-desc">{{item.video_description}}</div>
            <div class="hover-overlay-action">
              <v-btn dark small flat @click="readMore(key)">read more</v-btn>
              <v-btn
                dark
                small
                flat
                @click="editElement(item.video_name, item.upload_date, item.video_appointment, item.packet_id, item.video_description)"
              >edit</v-btn>
              <v-btn dark small flat @click="removeElement(item.video_name)">delete</v-btn>
            </div>
          </div>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="dialog" width="650">
      <v-carousel
        class="read-more-carousel"
        v-model="currentSlide"
        height="350"
        :cycle="false"
        light
        hide-delimiters
        prev-icon="arrow_back"
        next-icon="arrow_forward"
        style="position: relative"
      >
        <v-carousel-item v-for="(item, key) in videoArr" :key="key">
          <v-card
            dark
            height="100%"
            :style="{background: `transparent url(https://unsplash.it/360/200?image=${currentSlide + random}) center center no-repeat`, backgroundSize: 'cover'}"
          >
            <div class="read-more-carousel-item">
              <p class="read-more-carousel-header">{{item.video_name}}</p>
              <div class="read-more-carousel-info">
                <span>{{item.upload_date | changeDateFormat}}</span>
                <span>{{item.video_appointment}}</span>
              </div>
              <div class="read-more-carousel-desc">
                <p>{{item.video_description}}</p>
              </div>
              <div class="read-more-carousel-action">
                <v-btn dark small flat @click="editElement(item.video_name)">edit</v-btn>
                <v-btn dark small flat @click="removeElement(item.video_name)">delete</v-btn>
              </div>
            </div>
          </v-card>
        </v-carousel-item>
      </v-carousel>
    </v-dialog>
  </v-container>
</template>
<script>
import axios from "axios";
export default {
  name: "videos",
  data: () => ({
    show: null,
    dialog: false,
    random: 100,
    currentSlide: 0,
    videoArr: []
  }),
  created() {
    this.init();
  },
  methods: {
    init() {
      this.random = Math.floor(Math.random() * 100) + 1;
      console.log(this.random);
      axios
        .get(this.$hostname + "/admin/videos", {
          headers: {
            Authorization: localStorage.getItem("token")
          }
        })
        .then(response => {
          // this.videoArr = response.data.data;
          console.log(response);
          response.data.data.forEach(item => {
            if (item.exists) {
              this.videoArr.push(item);
            }
          });
          console.log(this.videoArr);
        });
    },
    mouseOver() {
      this.show = true;
    },
    mouseLeave() {
      this.show = false;
    },
    editElement(name, date, appointment, packet, description) {
      let fileData = {
        edit: true,
        videoName: name,
        date: date,
        appointment: appointment,
        packet: packet,
        description: description
      };
      console.log(fileData);
      this.$store.dispatch("addVideo", fileData);
      this.$router.push("edit-video");
    },
    removeElement(video) {
      let formData = new FormData();
      formData.append("video_name", video);
      formData.forEach((value, key) => {
        console.log("%s: %s", key, value);
      });
      axios
        .post(this.$hostname + "/admin/delete_video", formData, {
          headers: {
            Authorization: localStorage.getItem("token")
          }
        })
        .then(response => {
          console.log(response);
          this.init();
        });
      // this.itemsArr.splice(index, 1);
    },
    readMore(index) {
      this.currentSlide = index;
      this.dialog = true;
    },
    redirect() {
      this.$router.push("edit-video");
    }
  },
  filters: {
    changeDateFormat(value) {
      return value.split(" ")[0];
    }
  }
};
</script>
<style scoped lang="scss">
.v-card {
  .v-card__title {
    padding-top: 15px;
    padding-bottom: 0;
    color: #800057;
    font-weight: 700;
    height: 60px;
  }

  .v-card__text {
    padding-top: 0;
    font-weight: 700;

    span {
      opacity: 0.3;

      &:not(:last-of-type) {
        margin-right: 50px;
      }
    }
  }
}

.mbtn {
  position: absolute;
  top: 50%;
  left: -20px;
  height: 40px;
  width: 40px;
  background: #fff;
  z-index: 1000;
}

.hover-overlay {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 100%;
  min-height: 100%;
  max-height: 100%;
  background-color: #800057;
  color: #fff;
  display: flex;
  flex-direction: column;
  padding: 15px 0;

  .hover-overlay-title {
    padding-top: 15px;
    padding-left: 25px;
    padding-right: 25px;
    margin-bottom: 15px;
    font-weight: 700;
  }

  .hover-overlay-info {
    padding-left: 25px;
    padding-right: 25px;
    margin-bottom: 15px;

    span {
      opacity: 0.8;

      &:not(:last-of-type) {
        margin-right: 50px;
      }
    }
  }

  .hover-overlay-desc {
    overflow: hidden;
    position: relative;
    padding-left: 25px;
    padding-right: 25px;
    flex-grow: 1;

    &:before {
      content: "";
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      bottom: 0;
      background-image: linear-gradient(
        to top,
        rgba(#800057, 0),
        rgba(#800057, 1)
      );
    }
  }

  .hover-overlay-action {
    display: flex;
    justify-content: flex-end;
    padding: 0 25px;
    flex-shrink: 0;

    button {
      margin: 0;
      padding: 0;
      min-width: inherit;
      height: 24px;
      padding: 0 11px;

      &:first-of-type {
        margin-right: auto;
      }
    }
  }
}

.video-name {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
</style>
